import type { ConvexActionClient } from './convexTypes';
import { api } from '../../convex/_generated/api';
import type { SearchResult } from './types';

export class BraveClient {
  private convexClient: ConvexActionClient;

  constructor(convexClient: ConvexActionClient) {
    this.convexClient = convexClient;
  }

  async searchMultiple(queries: string[], options?: { numResults?: number; country?: string; lang?: string; safesearch?: 'off' | 'moderate' | 'strict' }): Promise<SearchResult[]> {
    try {
      const items = await this.convexClient.action(api.brave.searchMultiple as any, {
        queries,
        limit: options?.numResults ?? 10,
        country: options?.country,
        lang: options?.lang,
        safesearch: options?.safesearch ?? 'off',
      });

      const results = (items as any[]).map((r: any, index: number) => ({
        url: r.url,
        title: r.title || '',
        snippet: r.description || '',
        domain: new URL(r.url).hostname,
        rank: index + 1,
        source: 'brave' as const,
      })) as SearchResult[];

      return results;
    } catch (e: any) {
      console.error('Brave search error:', e?.message || e);
      return [];
    }
  }
}

